<template>
  <div class="production">

    <div class="head-links">
      <router-link class="back-links" to="/pediatrics">Головна</router-link>
      <span>/</span>
      <router-link class="back-links" to="/calculator">Калькулятор</router-link>
      <span>/</span>
      <span class="back-links now-page">{{ currentProd.name }}</span>
    </div>

    <div class="content-wrapper">

      <div class="content">

        <div class="production-block">

          <div class="production-item">
            <p class="name" v-html="currentProd.name"></p>
            <p class="type" v-html="currentProd.filters.name"></p>
            <img :src="require(`../assets/img/pack/${currentProd.img}`)" alt="">
          </div>

          <div class="hide"
               v-bind:class="[{ active: numberProduction.toString() === '26' ||numberProduction.toString() === '25' || numberProduction.toString() === '19' || numberProduction.toString() === '20'||numberProduction.toString() === '21'||numberProduction.toString() === '22'||numberProduction.toString() === '23'||numberProduction.toString() === '24' || numberProduction.toString() === '18' || numberProduction.toString() === 'base-3-powder-POF'|| numberProduction.toString() === 'base-4-powder-POF'|| numberProduction.toString() === 'preterm-powder-Midas'|| numberProduction.toString() === 'base-3-powder-Profutura-Duobiotic'|| numberProduction.toString() === 'ketocal-4-1'|| numberProduction.toString() === 'ketocal-3-1' }]">

            <div class="drop-item1" v-bind:class="[dropList2 !== false ? activeClass: '', ``]">
              <p @click="openDropListAge()" class="visible-item">
                <svg class="icon" width="34" height="27" viewBox="0 0 34 27" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M29.1586 15.8381L29.1585 15.8383C27.9975 21.0915 23.0151 24.9128 17.3056 24.9128C11.5962 24.9128 6.6149 21.0916 5.45376 15.8385C5.39423 15.565 5.15179 15.3715 4.87382 15.3715H4.54969C3.19272 15.3715 2.08822 14.2669 2.08822 12.911C2.08822 11.555 3.19277 10.4496 4.54969 10.4496H5.2029C5.4581 10.4496 5.68513 10.287 5.76609 10.0445C7.36714 5.28932 12.0031 2.08822 17.3056 2.08822C22.6082 2.08822 27.2432 5.28931 28.8452 10.0445L28.8452 10.0446C28.9271 10.2866 29.1528 10.4496 29.4084 10.4496H30.0626C31.4195 10.4496 32.5231 11.554 32.5231 12.911C32.5231 14.268 31.4195 15.3715 30.0626 15.3715H29.7384C29.4599 15.3715 29.2191 15.5665 29.1586 15.8381ZM0.9 12.911C0.9 14.875 2.45941 16.4814 4.40558 16.5566C5.86949 22.1176 11.2172 26.1 17.3056 26.1C23.394 26.1 28.7428 22.1176 30.2086 16.5566C32.1539 16.4814 33.7132 14.875 33.7132 12.911C33.7132 10.8981 32.0755 9.26133 30.0646 9.26133H29.8286C27.9415 4.23972 22.963 0.9 17.3066 0.9C11.6502 0.9 6.67171 4.23972 4.7846 9.26133H4.54969C2.53678 9.26133 0.9 10.8991 0.9 12.911Z"
                      fill="#1E3B89" stroke="#1E3B89" stroke-width="0.2"/>
                  <path
                      d="M21.4467 16.1106C22.1612 16.1106 22.7405 15.5313 22.7405 14.8168C22.7405 14.1023 22.1612 13.523 21.4467 13.523C20.7322 13.523 20.1529 14.1023 20.1529 14.8168C20.1529 15.5313 20.7322 16.1106 21.4467 16.1106Z"
                      fill="#1E3B89" stroke="#1E3B89" stroke-width="0.2"/>
                  <path
                      d="M13.6205 16.1106C14.3351 16.1106 14.9143 15.5313 14.9143 14.8168C14.9143 14.1023 14.3351 13.523 13.6205 13.523C12.906 13.523 12.3268 14.1023 12.3268 14.8168C12.3268 15.5313 12.906 16.1106 13.6205 16.1106Z"
                      fill="#1E3B89" stroke="#1E3B89" stroke-width="0.2"/>
                  <path
                      d="M13.5654 20.2467L13.5654 20.2467L13.566 20.247L13.7605 20.3665C13.7605 20.3665 13.7605 20.3665 13.7606 20.3665C14.8526 21.0394 16.0774 21.3755 17.3044 21.3755C18.5304 21.3755 19.7571 21.0384 20.8511 20.3656L20.8512 20.3655L21.0449 20.2459L21.0451 20.2458C21.3229 20.0737 21.411 19.7079 21.2386 19.4284C21.066 19.1487 20.699 19.0649 20.4214 19.2345L20.4214 19.2345L20.4209 19.2349L20.2285 19.3543C20.2284 19.3543 20.2284 19.3543 20.2283 19.3543C18.4224 20.466 16.1842 20.465 14.3833 19.3553L14.1896 19.2357L14.1896 19.2357L14.1893 19.2355C13.9115 19.0658 13.5458 19.1499 13.3723 19.4291L13.3723 19.4291L13.3721 19.4294C13.1995 19.7091 13.288 20.0736 13.5654 20.2467Z"
                      fill="#1E3B89" stroke="#1E3B89" stroke-width="0.2"/>
                </svg>

                <span>{{ filter2Chose }}</span>

                <svg class="arrow" width="12" height="7" viewBox="0 0 12 7" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.7783 1.24219L6.26562 5.77767" stroke="#00ACE6" stroke-width="2"
                        stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6.26608 5.77767L1.75684 1.24219" stroke="#00ACE6" stroke-width="2"
                        stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>

              </p>

              <div class="hide-item ">
                <p v-bind:class="[currentProd.filter2Chose === key.name ? activeClass: '', ``]"
                   v-for="(key, value) in currentProd.filterItemDrop2" v-html="key.name"
                   @click="choseFilter2(key.type, key.name)"></p>

              </div>
            </div>

            <div class="drop-item2"
                 v-bind:class="[dropList3 !== false ? activeClass: '', ``]"
                 v-if="filter2Type === '0-10'">
              <p @click="openDropListAge2()" class="visible-item">
                <svg class="icon" width="34" height="27" viewBox="0 0 34 27" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M29.1586 15.8381L29.1585 15.8383C27.9975 21.0915 23.0151 24.9128 17.3056 24.9128C11.5962 24.9128 6.6149 21.0916 5.45376 15.8385C5.39423 15.565 5.15179 15.3715 4.87382 15.3715H4.54969C3.19272 15.3715 2.08822 14.2669 2.08822 12.911C2.08822 11.555 3.19277 10.4496 4.54969 10.4496H5.2029C5.4581 10.4496 5.68513 10.287 5.76609 10.0445C7.36714 5.28932 12.0031 2.08822 17.3056 2.08822C22.6082 2.08822 27.2432 5.28931 28.8452 10.0445L28.8452 10.0446C28.9271 10.2866 29.1528 10.4496 29.4084 10.4496H30.0626C31.4195 10.4496 32.5231 11.554 32.5231 12.911C32.5231 14.268 31.4195 15.3715 30.0626 15.3715H29.7384C29.4599 15.3715 29.2191 15.5665 29.1586 15.8381ZM0.9 12.911C0.9 14.875 2.45941 16.4814 4.40558 16.5566C5.86949 22.1176 11.2172 26.1 17.3056 26.1C23.394 26.1 28.7428 22.1176 30.2086 16.5566C32.1539 16.4814 33.7132 14.875 33.7132 12.911C33.7132 10.8981 32.0755 9.26133 30.0646 9.26133H29.8286C27.9415 4.23972 22.963 0.9 17.3066 0.9C11.6502 0.9 6.67171 4.23972 4.7846 9.26133H4.54969C2.53678 9.26133 0.9 10.8991 0.9 12.911Z"
                      fill="#1E3B89" stroke="#1E3B89" stroke-width="0.2"/>
                  <path
                      d="M21.4467 16.1106C22.1612 16.1106 22.7405 15.5313 22.7405 14.8168C22.7405 14.1023 22.1612 13.523 21.4467 13.523C20.7322 13.523 20.1529 14.1023 20.1529 14.8168C20.1529 15.5313 20.7322 16.1106 21.4467 16.1106Z"
                      fill="#1E3B89" stroke="#1E3B89" stroke-width="0.2"/>
                  <path
                      d="M13.6205 16.1106C14.3351 16.1106 14.9143 15.5313 14.9143 14.8168C14.9143 14.1023 14.3351 13.523 13.6205 13.523C12.906 13.523 12.3268 14.1023 12.3268 14.8168C12.3268 15.5313 12.906 16.1106 13.6205 16.1106Z"
                      fill="#1E3B89" stroke="#1E3B89" stroke-width="0.2"/>
                  <path
                      d="M13.5654 20.2467L13.5654 20.2467L13.566 20.247L13.7605 20.3665C13.7605 20.3665 13.7605 20.3665 13.7606 20.3665C14.8526 21.0394 16.0774 21.3755 17.3044 21.3755C18.5304 21.3755 19.7571 21.0384 20.8511 20.3656L20.8512 20.3655L21.0449 20.2459L21.0451 20.2458C21.3229 20.0737 21.411 19.7079 21.2386 19.4284C21.066 19.1487 20.699 19.0649 20.4214 19.2345L20.4214 19.2345L20.4209 19.2349L20.2285 19.3543C20.2284 19.3543 20.2284 19.3543 20.2283 19.3543C18.4224 20.466 16.1842 20.465 14.3833 19.3553L14.1896 19.2357L14.1896 19.2357L14.1893 19.2355C13.9115 19.0658 13.5458 19.1499 13.3723 19.4291L13.3723 19.4291L13.3721 19.4294C13.1995 19.7091 13.288 20.0736 13.5654 20.2467Z"
                      fill="#1E3B89" stroke="#1E3B89" stroke-width="0.2"/>
                </svg>

                <span>{{ filter3Chose }}</span>

                <svg class="arrow" width="12" height="7" viewBox="0 0 12 7" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.7783 1.24219L6.26562 5.77767" stroke="#00ACE6" stroke-width="2"
                        stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6.26608 5.77767L1.75684 1.24219" stroke="#00ACE6" stroke-width="2"
                        stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>

              </p>

              <div class="hide-item">
                <p v-bind:class="[filter3Chose === key.name ? activeClass: '', ``]"
                   v-for="(key, value) in days" v-html="key.name"
                   @click="choseFilter3(key.type, key.name)"></p>

              </div>
            </div>

            <div class="weight-block" v-if="filter2Type !== '0-10'">

              <div class="left">

                <svg width="37" height="21" viewBox="0 0 37 21" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M10.9165 12.6151H10.9167H26.0833L26.0835 12.6151C30.3893 12.6082 33.9597 9.17489 34.3132 4.73526C35.309 4.70071 36.1 3.85217 36.1 2.81818C36.1 1.76242 35.2753 0.9 34.25 0.9H2.75C1.72469 0.9 0.9 1.76242 0.9 2.81818C0.9 3.85217 1.69104 4.70071 2.68684 4.73526C3.04031 9.17489 6.61075 12.6082 10.9165 12.6151ZM26.0832 11.203H10.9168C7.36874 11.1984 4.40266 8.40101 4.05045 4.73636H32.9496C32.5973 8.40101 29.6313 11.1984 26.0832 11.203ZM34.25 3.32424H2.75C2.48665 3.32424 2.26667 3.10128 2.26667 2.81818C2.26667 2.53507 2.48665 2.31212 2.75 2.31212H34.25C34.5133 2.31212 34.7333 2.53507 34.7333 2.81818C34.7333 3.10128 34.5133 3.32424 34.25 3.32424Z"
                      fill="#1E3B89" stroke="#1E3B89" stroke-width="0.2"/>
                  <path
                      d="M26.537 12.8783L26.3884 12.7712L26.3127 12.938L25.9269 13.7882L25.8762 13.9L25.9758 13.9718C27.2625 14.8996 28.0699 16.6352 28.0722 18.531C28.0721 18.7526 27.9348 18.8706 27.8333 18.8706H9.16667C9.06517 18.8706 8.92783 18.7526 8.92778 18.531C8.931 16.6456 9.72967 14.9182 11.0052 13.9859L11.1041 13.9136L11.053 13.8023L10.6641 12.9546L10.5875 12.7877L10.4393 12.896C8.83231 14.0704 7.85405 16.2191 7.85 18.5306V18.5309C7.85 19.391 8.40908 20.15 9.16667 20.15H27.8333C28.5909 20.15 29.15 19.391 29.15 18.5309V18.5307C29.1471 16.2066 28.1584 14.0476 26.537 12.8783Z"
                      fill="#1E3B89" stroke="#1E3B89" stroke-width="0.3"/>
                  <path
                      d="M13 13.85H12.85V14V17V17.15H13H24H24.15V17V14V13.85H24H13ZM23.1167 16.1H13.8833V14.9H23.1167V16.1Z"
                      fill="#1E3B89" stroke="#1E3B89" stroke-width="0.3"/>
                </svg>

                <p>Вага</p>

              </div>

              <div class="right">

                <div class="minus" @mousedown="startMinus" @mouseleave="stop" @mouseup="stop"
                     @touchstart="startMinus" @touchend="stop" @touchcancel="stop" @click="minusWeight()">
                  <svg width="26" height="3" viewBox="0 0 26 3" fill="none"
                       xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M1.87598 2.37425C1.38357 2.37425 0.992188 1.97093 0.992188 1.47852C0.992188 0.98611 1.38357 0.594727 1.87598 0.594727H25.0957C25.5881 0.594727 25.9922 0.98611 25.9922 1.47852C25.9922 1.97093 25.5881 2.37504 25.0957 2.37504H1.87598V2.37425Z"
                        fill="#00ACE6"/>
                  </svg>
                </div>

                <p>{{ weight }} кг</p>

                <div class="plus" @mousedown="startPlus" @mouseleave="stop" @mouseup="stop"
                     @touchstart="startPlus" @touchend="stop" @touchcancel="stop" @click="plusWeight()">
                  <svg width="25" height="25" viewBox="0 0 25 25" fill="none"
                       xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M0.883316 13.3897C0.391172 13.3897 0 12.9858 0 12.4936C0 12.0015 0.391172 11.6103 0.883316 11.6103H11.5968V0.896037C11.5976 0.403893 12.0015 0 12.4936 0C12.9858 0 13.377 0.403893 13.377 0.896037V11.6103H24.0904C24.5826 11.6103 24.9865 12.0015 24.9865 12.4936C24.9865 12.9858 24.5826 13.3897 24.0904 13.3897H13.377V24.104C13.377 24.5961 12.9858 25 12.4936 25C12.0015 25 11.5976 24.5961 11.5976 24.104V13.3897H0.883316Z"
                        fill="#00ACE6"/>
                  </svg>

                </div>

              </div>

            </div>

            <div class="calc-btn-wrapper">
              <div :class="`${currentProd.gtm} calc-btn`" @click="calcResult()">
                <p :class="`${currentProd.gtm}`" v-if="showResult=== false">розрахувати</p>
                <p :class="`${currentProd.gtm}`" v-if="showResult=== true">розрахувати знову</p>
              </div>

              <router-link
                  to="/pediatrics/sampling"
                  class="sampling-btn"
                  v-if="!(['base-1-powder-Profutura-Duobiotic','base-2-powder-Profutura-Duobiotic','base-3-powder-Profutura-Duobiotic','6', '7', '5', '8', '9', '10', '16', 'base-2-powder-POF', 'base-1-powder-POF', 'base-1-liquid-POF', 'sensitive-1', 'sensitive-2'].includes(currentProd.id))"
              >
                <p>Замовити зразки</p>
              </router-link>
            </div>

            <div v-bind:class="[showResult === true ? activeClass: '', ``]" class="result-wrapper">

              <div ref="printMe" id="result-img" class="result-img">

                <div class="line1 line">
                  <div class="icon-wrapper">
                    <svg width="35" height="35" viewBox="0 0 35 35" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M17.5 0C7.83502 0 0 7.83502 0 17.5C0 27.165 7.83502 35 17.5 35C27.165 35 35 27.165 35 17.5C34.9876 7.84018 27.1598 0.0123874 17.5 0ZM18.2508 33.461V30.3829C18.2508 29.9683 17.9146 29.6321 17.5 29.6321C17.0854 29.6321 16.7493 29.9683 16.7493 30.3829V33.461C8.51717 33.0679 1.93206 26.4828 1.53904 18.2508H4.61712C5.03172 18.2508 5.36787 17.9146 5.36787 17.5C5.36787 17.0854 5.03172 16.7493 4.61712 16.7493H1.53904C1.93206 8.51717 8.51717 1.93206 16.7493 1.53904V4.61712C16.7493 5.03172 17.0854 5.36787 17.5 5.36787C17.9146 5.36787 18.2508 5.03172 18.2508 4.61712V1.53904C26.4828 1.93206 33.0679 8.51717 33.461 16.7493H30.3829C29.9683 16.7493 29.6321 17.0854 29.6321 17.5C29.6321 17.9146 29.9683 18.2508 30.3829 18.2508H30.3904H33.4685C33.0752 26.4855 26.4857 33.0717 18.2508 33.461Z"
                          fill="#1E3B89"/>
                      <path
                          d="M25.4202 24.4809L18.2505 17.1911V9.61599C18.2505 9.20138 17.9144 8.86523 17.4998 8.86523C17.0852 8.86523 16.749 9.20138 16.749 9.61599V17.4989C16.7499 17.6958 16.828 17.8846 16.9667 18.0244L24.3466 25.5319C24.6369 25.8284 25.1125 25.8334 25.4089 25.5432C25.7054 25.2529 25.7105 24.7773 25.4202 24.4809Z"
                          fill="#1E3B89"/>
                    </svg>

                  </div>
                  <p>Добова норма: <br> <span><span>{{ result.dailyRate }}</span> мл</span></p>
                </div>

                <div class="line2 line">

                  <div class="icon-wrapper">
                    <svg width="26" height="53" viewBox="0 0 26 53" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M22.3036 51.3609H3.65193C2.19006 51.3609 1 50.1662 1 48.7149V19.7046C1 18.2533 2.19006 17.0586 3.65193 17.0586H22.3036C23.7581 17.0586 24.9555 18.246 24.9555 19.7046V48.7149C24.9482 50.1662 23.7581 51.3609 22.3036 51.3609Z"
                          stroke="#1E3B89" stroke-width="1.5" stroke-miterlimit="10"
                          stroke-linecap="round" stroke-linejoin="round"/>
                      <path
                          d="M5.07715 17.0649V15.0493C5.07715 13.598 6.26721 12.418 7.71439 12.418H18.234C19.6885 12.418 20.8712 13.6054 20.8712 15.0493V17.0649"
                          stroke="#1E3B89" stroke-width="1.5" stroke-miterlimit="10"
                          stroke-linecap="round" stroke-linejoin="round"/>
                      <path
                          d="M15.8026 12.4184C17.4555 12.4184 18.1607 10.6154 18.1607 9.31803C18.1607 8.0207 15.854 6.34223 15.854 6.34223C15.5528 0.47126 13.4519 1.01365 13.4519 1.01365H12.5116C12.5116 1.01365 10.4106 0.463931 10.1094 6.34223C10.1094 6.34223 7.80273 8.01337 7.80273 9.31803C7.80273 10.6154 8.50061 12.4184 10.1608 12.4184"
                          stroke="#1E3B89" stroke-width="1.5" stroke-miterlimit="10"
                          stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M24.9477 22.46H14.4648" stroke="#1E3B89" stroke-width="1.5"
                            stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M24.9477 27.8838H14.4648" stroke="#1E3B89" stroke-width="1.5"
                            stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M24.9477 33.3145H14.4648" stroke="#1E3B89" stroke-width="1.5"
                            stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M24.9477 38.7461H14.4648" stroke="#1E3B89" stroke-width="1.5"
                            stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M24.9477 44.1699H14.4648" stroke="#1E3B89" stroke-width="1.5"
                            stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>

                  </div>

                  <p>
                    <span><span>{{ result.NumberOfFeedings }}</span> годувань</span><br>
                    {{ currentProd.resultBlock.line2 }}
                  </p>

                </div>

                <div class="line3 line" v-if="numberProduction !== 'base-1-liquid-POF'">

                  <div class="icon-wrapper">
                    <svg width="28" height="42" viewBox="0 0 28 42" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M3.57129 13.9512L7.32513 37.8528C7.58224 39.6559 9.13226 40.9972 10.9614 40.9972H19.0715C20.908 40.9972 22.4654 39.6413 22.7078 37.8235L26.2559 13.9512H3.57129V13.9512Z"
                          stroke="#1E3B89" stroke-width="1.5" stroke-miterlimit="10"
                          stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M8.21387 26.375H21.4368" stroke="#1E3B89" stroke-width="1.5"
                            stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M1 1L2.10191 7.7212H13.1063L14.5168 1H1Z" stroke="#1E3B89"
                            stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                            stroke-linejoin="round"/>
                      <path d="M14.5166 1H26.9608" stroke="#1E3B89" stroke-width="1.5"
                            stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>

                  <p>
                    <span><span>{{ result.tablespoons }}</span> {{ result.spooneText }} + <span>{{
                        result.water
                      }}</span> мл води</span><br>
                    {{ currentProd.resultBlock.line3 }}
                  </p>

                </div>

              </div>

              <div class="save-btn">
                <div @click="saveImg()" class="btns load-to-gallery saved-results-gallery">
                  <svg class="saved-results-gallery" width="45" height="45" viewBox="0 0 45 45"
                       fill="none"
                       xmlns="http://www.w3.org/2000/svg">
                    <circle cx="22.5" cy="22.5" r="22.5" fill="white" fill-opacity="0.25"/>
                    <path
                        d="M34.2837 22.2106C33.8858 22.2106 33.5675 22.5289 33.5675 22.9269V29.4421C33.5675 31.2142 32.1244 32.652 30.3576 32.652H14.6424C12.8703 32.652 11.4325 31.2089 11.4325 29.4421V22.8207C11.4325 22.4228 11.1142 22.1045 10.7163 22.1045C10.3183 22.1045 10 22.4228 10 22.8207V29.4421C10 32.0047 12.0851 34.0845 14.6424 34.0845H30.3576C32.9202 34.0845 35 31.9994 35 29.4421V22.9269C35 22.5342 34.6817 22.2106 34.2837 22.2106Z"
                        fill="white"/>
                    <path
                        d="M21.9959 26.397C22.1339 26.5349 22.3196 26.6092 22.5 26.6092C22.6804 26.6092 22.8661 26.5403 23.004 26.397L27.5562 21.8448C27.8374 21.5636 27.8374 21.1126 27.5562 20.8314C27.275 20.5502 26.824 20.5502 26.5428 20.8314L23.2162 24.1633V9.6313C23.2162 9.23338 22.8979 8.91504 22.5 8.91504C22.1021 8.91504 21.7837 9.23338 21.7837 9.6313V24.1633L18.4518 20.8314C18.1706 20.5502 17.7196 20.5502 17.4384 20.8314C17.1572 21.1126 17.1572 21.5636 17.4384 21.8448L21.9959 26.397Z"
                        fill="white"/>
                  </svg>
                  <p class="saved-results-gallery">Зберегти в галерею</p>

                </div>
                <a id="viber_share" style="display: none;" href=""></a>
                <div @click="sendToServerScreen()" class="btns share send-results">

                  <svg class="send-results" width="45" height="45" viewBox="0 0 45 45" fill="none"
                       xmlns="http://www.w3.org/2000/svg">
                    <circle cx="22.5" cy="22.5" r="22.5" fill="white" fill-opacity="0.25"/>
                    <path
                        d="M29.8084 26.061C28.3705 26.061 27.0883 26.7463 26.2681 27.8052L19.4004 23.9691C19.5613 23.5071 19.6496 23.0087 19.6496 22.4948C19.6496 21.9757 19.5613 21.4826 19.3952 21.0154L26.2578 17.1844C27.0728 18.2485 28.3601 18.939 29.8032 18.939C32.2638 18.939 34.2727 16.9352 34.2727 14.4695C34.2727 12.0037 32.269 10 29.8032 10C27.3375 10 25.3338 12.0037 25.3338 14.4695C25.3338 14.9886 25.422 15.4869 25.5881 15.9489L18.7308 19.7799C17.9158 18.7105 16.6284 18.0253 15.1853 18.0253C12.7247 18.0253 10.7158 20.0291 10.7158 22.4948C10.7158 24.9605 12.7247 26.9643 15.1905 26.9643C16.6336 26.9643 17.921 26.2739 18.7412 25.2045L25.6037 29.0407C25.4376 29.5079 25.3441 30.0114 25.3441 30.5305C25.3441 32.9911 27.3479 35 29.8136 35C32.2794 35 34.2831 32.9963 34.2831 30.5305C34.2831 28.0648 32.2742 26.061 29.8084 26.061ZM29.8084 11.4068C31.5007 11.4068 32.8763 12.7824 32.8763 14.4747C32.8763 16.1669 31.5007 17.5426 29.8084 17.5426C28.1162 17.5426 26.7405 16.1669 26.7405 14.4747C26.7405 12.7824 28.1213 11.4068 29.8084 11.4068ZM15.1905 25.5627C13.4982 25.5627 12.1226 24.1871 12.1226 22.4948C12.1226 20.8025 13.4982 19.4269 15.1905 19.4269C16.8828 19.4269 18.2584 20.8025 18.2584 22.4948C18.2584 24.1871 16.8776 25.5627 15.1905 25.5627ZM29.8084 33.5932C28.1162 33.5932 26.7405 32.2176 26.7405 30.5253C26.7405 28.8331 28.1162 27.4574 29.8084 27.4574C31.5007 27.4574 32.8763 28.8331 32.8763 30.5253C32.8763 32.2176 31.5007 33.5932 29.8084 33.5932Z"
                        fill="white"/>
                  </svg>

                  <p class="send-results">Відправити результат</p>

                </div>
                <router-link to="/instruction">
                  <div class="btns download-app">
                    <svg width="45" height="45" viewBox="0 0 45 45" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                      <circle cx="22.5" cy="22.5" r="22.5" fill="white" fill-opacity="0.25"/>
                      <path
                          d="M17.5161 35.9883L17.5162 35.8883H17.5163H17.5165H17.5168H17.5172H17.5176H17.5181H17.5188H17.5194H17.5202H17.5211H17.522H17.523H17.5241H17.5253H17.5265H17.5279H17.5293H17.5308H17.5323H17.534H17.5357H17.5375H17.5394H17.5413H17.5434H17.5455H17.5477H17.5499H17.5523H17.5547H17.5572H17.5597H17.5624H17.5651H17.5679H17.5708H17.5737H17.5767H17.5798H17.583H17.5862H17.5895H17.5929H17.5964H17.5999H17.6035H17.6072H17.6109H17.6147H17.6186H17.6226H17.6266H17.6307H17.6349H17.6391H17.6434H17.6478H17.6523H17.6568H17.6614H17.666H17.6708H17.6756H17.6804H17.6854H17.6904H17.6954H17.7006H17.7058H17.7111H17.7164H17.7218H17.7273H17.7328H17.7384H17.7441H17.7498H17.7556H17.7615H17.7674H17.7734H17.7795H17.7856H17.7918H17.7981H17.8044H17.8108H17.8172H17.8237H17.8303H17.8369H17.8436H17.8504H17.8572H17.8641H17.871H17.878H17.8851H17.8922H17.8994H17.9067H17.914H17.9213H17.9288H17.9362H17.9438H17.9514H17.9591H17.9668H17.9746H17.9824H17.9903H17.9983H18.0063H18.0143H18.0225H18.0306H18.0389H18.0472H18.0555H18.0639H18.0724H18.0809H18.0895H18.0981H18.1068H18.1156H18.1244H18.1332H18.1421H18.1511H18.1601H18.1691H18.1783H18.1874H18.1967H18.2059H18.2153H18.2246H18.2341H18.2436H18.2531H18.2627H18.2723H18.282H18.2917H18.3015H18.3114H18.3213H18.3312H18.3412H18.3512H18.3613H18.3714H18.3816H18.3919H18.4021H18.4125H18.4228H18.4333H18.4437H18.4542H18.4648H18.4754H18.4861H18.4968H18.5075H18.5183H18.5292H18.54H18.551H18.562H18.573H18.584H18.5951H18.6063H18.6175H18.6287H18.64H18.6513H18.6627H18.6741H18.6856H18.6971H18.7086H18.7202H18.7318H18.7435H18.7552H18.7669H18.7787H18.7905H18.8024H18.8143H18.8263H18.8382H18.8503H18.8623H18.8744H18.8866H18.8988H18.911H18.9232H18.9355H18.9479H18.9602H18.9726H18.9851H18.9976H19.0101H19.0226H19.0352H19.0478H19.0605H19.0732H19.0859H19.0987H19.1115H19.1243H19.1372H19.1501H19.163H19.176H19.189H19.2021H19.2151H19.2282H19.2414H19.2545H19.2677H19.281H19.2942H19.3075H19.3209H19.3342H19.3476H19.361H19.3745H19.388H19.4015H19.415H19.4286H19.4422H19.4558H19.4695H19.4832H19.4969H19.5106H19.5244H19.5382H19.552H19.5659H19.5797H19.5936H19.6076H19.6215H19.6355H19.6495H19.6636H19.6776H19.6917H19.7058H19.72H19.7341H19.7483H19.7625H19.7768H19.791H19.8053H19.8196H19.834H19.8483H19.8627H19.8771H19.8915H19.9059H19.9204H19.9349H19.9494H19.9639H19.9785H19.9931H20.0076H20.0223H20.0369H20.0515H20.0662H20.0809H20.0956H20.1103H20.1251H20.1398H20.1546H20.1694H20.1843H20.1991H20.2139H20.2288H20.2437H20.2586H20.2735H20.2885H20.3034H20.3184H20.3334H20.3484H20.3634H20.3784H20.3935H20.4086H20.4236H20.4387H20.4538H20.4689H20.4841H20.4992H20.5144H20.5295H20.5447H20.5599H20.5751H20.5904H20.6056H20.6208H20.6361H20.6514H20.6666H20.6819H20.6972H20.7125H20.7278H20.7432H20.7585H20.7739H20.7892H20.8046H20.82H20.8353H20.8507H20.8661H20.8815H20.8969H20.9124H20.9278H20.9432H20.9587H20.9741H20.9896H21.005H21.0205H21.036H21.0514H21.0669H21.0824H21.0979H21.1134H21.1289H21.1444H21.1599H21.1754H21.191H21.2065H21.222H21.2375H21.2531H21.2686H21.2841H21.2997H21.3152H21.3307H21.3463H21.3618H21.3773H21.3929H21.4084H21.424H21.4395H21.4551H21.4706H21.4861H21.5017H21.5172H21.5327H21.5483H21.5638H21.5793H21.5949H21.6104H21.6259H21.6414H21.657H21.6725H21.688H21.7035H21.719H21.7345H21.75H21.7655H21.781H21.7964H21.8119H21.8274H21.8429H21.8583H21.8738H21.8892H21.9046H21.9201H21.9355H21.9509H21.9663H21.9817H21.9971H22.0125H22.0279H22.0432H22.0586H22.074H22.0893H22.1046H22.12H22.1353H22.1506H22.1659H22.1811H22.1964H22.2117H22.2269H22.2422H22.2574H22.2726H22.2878H22.303H22.3182H22.3333H22.3485H22.3636H22.3787H22.3938H22.4089H22.424H22.4391H22.4541H22.4692H22.4842H22.4992H22.5142H22.5292H22.5441H22.5591H22.574H22.5889H22.6038H22.6187H22.6336H22.6484H22.6632H22.678H22.6928H22.7076H22.7223H22.7371H22.7518H22.7665H22.7812H22.7958H22.8105H22.8251H22.8397H22.8543H22.8688H22.8834H22.8979H22.9124H22.9268H22.9413H22.9557H22.9701H22.9845H22.9989H23.0132H23.0275H23.0418H23.0561H23.0703H23.0845H23.0987H23.1129H23.1271H23.1412H23.1553H23.1694H23.1834H23.1974H23.2114H23.2254H23.2393H23.2532H23.2671H23.281H23.2948H23.3086H23.3224H23.3362H23.3499H23.3636H23.3773H23.3909H23.4045H23.4181H23.4316C23.8756 35.8883 24.2383 35.898 24.58 35.9072C25.2025 35.924 25.7554 35.9389 26.6033 35.8895C27.0438 35.6942 27.3516 35.2533 27.3516 34.7419V31.6806H20.871C20.0689 31.6806 19.4161 31.0279 19.4161 30.2258V15.8043C19.4161 15.0022 20.0689 14.3495 20.871 14.3495H27.3516V11.2581C27.3516 10.5664 26.7884 10.0032 26.0968 10.0032H25.7452V10.3548C25.7452 11.1569 25.0924 11.8097 24.2903 11.8097H17.0645C16.2624 11.8097 15.6097 11.1569 15.6097 10.3548V10.0032H15.2581C14.5664 10.0032 14.0032 10.5664 14.0032 11.2581V34.7419C14.0032 35.2522 14.3097 35.6923 14.7488 35.8883H14.7497H14.757H14.7643H14.7716H14.7789H14.7862H14.7935H14.8008H14.8081H14.8154H14.8228H14.8301H14.8374H14.8448H14.8521H14.8595H14.8669H14.8742H14.8816H14.889H14.8964H14.9038H14.9112H14.9186H14.926H14.9334H14.9408H14.9483H14.9557H14.9631H14.9706H14.978H14.9854H14.9929H15.0003H15.0078H15.0153H15.0227H15.0302H15.0377H15.0452H15.0526H15.0601H15.0676H15.0751H15.0826H15.0901H15.0976H15.1051H15.1126H15.1201H15.1276H15.1352H15.1427H15.1502H15.1577H15.1653H15.1728H15.1803H15.1878H15.1954H15.2029H15.2105H15.218H15.2255H15.2331H15.2406H15.2482H15.2557H15.2633H15.2708H15.2784H15.2859H15.2935H15.301H15.3086H15.3161H15.3237H15.3313H15.3388H15.3464H15.3539H15.3615H15.369H15.3766H15.3842H15.3917H15.3993H15.4068H15.4144H15.4219H15.4295H15.4371H15.4446H15.4522H15.4597H15.4673H15.4748H15.4824H15.4899H15.4975H15.505H15.5126H15.5201H15.5276H15.5352H15.5427H15.5503H15.5578H15.5653H15.5728H15.5804H15.5879H15.5954H15.6029H15.6105H15.618H15.6255H15.633H15.6405H15.648H15.6555H15.663H15.6705H15.678H15.6855H15.693H15.7004H15.7079H15.7154H15.7229H15.7303H15.7378H15.7452H15.7527H15.7601H15.7676H15.775H15.7825H15.7899H15.7973H15.8047H15.8122H15.8196H15.827H15.8344H15.8418H15.8492H15.8565H15.8639H15.8713H15.8787H15.886H15.8934H15.9007H15.9081H15.9154H15.9228H15.9301H15.9374H15.9447H15.952H15.9593H15.9666H15.9739H15.9812H15.9885H15.9958H16.003H16.0103H16.0175H16.0248H16.032H16.0392H16.0464H16.0537H16.0609H16.068H16.0752H16.0824H16.0896H16.0968H16.1039H16.1111H16.1182H16.1253H16.1324H16.1396H16.1467H16.1538H16.1608H16.1679H16.175H16.1821H16.1891H16.1961H16.2032H16.2102H16.2172H16.2242H16.2312H16.2382H16.2452H16.2521H16.2591H16.266H16.273H16.2799H16.2868H16.2937H16.3006H16.3075H16.3144H16.3212H16.3281H16.3349H16.3417H16.3486H16.3554H16.3622H16.369H16.3757H16.3825H16.3892H16.396H16.4027H16.4094H16.4161H16.4228H16.4295H16.4361H16.4428H16.4494H16.4561H16.4627H16.4693H16.4759H16.4825H16.489H16.4956H16.5021H16.5087H16.5152H16.5217H16.5282H16.5346H16.5411H16.5475H16.554H16.5604H16.5668H16.5732H16.5796H16.5859H16.5923H16.5986H16.6049H16.6112H16.6175H16.6238H16.6301H16.6363H16.6425H16.6488H16.655H16.6612H16.6673H16.6735H16.6796H16.6858H16.6919H16.698H16.704H16.7101H16.7162H16.7222H16.7282H16.7342H16.7402H16.7462H16.7521H16.758H16.764H16.7699H16.7758H16.7816H16.7875H16.7933H16.7991H16.8049H16.8107H16.8165H16.8222H16.828H16.8337H16.8394H16.8451H16.8507H16.8564H16.862H16.8676H16.8732H16.8788H16.8843H16.8898H16.8954H16.9009H16.9063H16.9118H16.9172H16.9227H16.9281H16.9335H16.9388H16.9442H16.9495H16.9548H16.9601H16.9654H16.9706H16.9759H16.9811H16.9863H16.9914H16.9966H17.0017H17.0068H17.0119H17.017H17.022H17.0271H17.0321H17.0371H17.042H17.047H17.0519H17.0568H17.0617H17.0665H17.0714H17.0762H17.081H17.0858H17.0905H17.0953H17.1H17.1047H17.1093H17.114H17.1186H17.1232H17.1278H17.1324H17.1369H17.1414H17.1459H17.1504H17.1548H17.1592H17.1636H17.168H17.1724H17.1767H17.181H17.1853H17.1895H17.1938H17.198H17.2022H17.2063H17.2105H17.2146H17.2187H17.2228H17.2268H17.2308H17.2348H17.2388H17.2427H17.2467H17.2506H17.2544H17.2583H17.2621H17.2659H17.2697H17.2734H17.2772H17.2808H17.2845H17.2882H17.2918H17.2954H17.299H17.3025H17.306H17.3095H17.313H17.3164H17.3198H17.3232H17.3266H17.3299H17.3332H17.3365H17.3398H17.343H17.3462H17.3494H17.3525H17.3556H17.3587H17.3618H17.3648H17.3678H17.3708H17.3738H17.3767H17.3796H17.3825H17.3853H17.3881H17.3909H17.3937H17.3964H17.3991H17.4018H17.4044H17.407H17.4096H17.4122H17.4147H17.4172H17.4197H17.4221H17.4246H17.4269H17.4293H17.4316H17.4339H17.4362H17.4384H17.4406H17.4428H17.4449H17.4471H17.4491H17.4512H17.4532H17.4552H17.4572H17.4591H17.461H17.4629H17.4647H17.4666H17.4683H17.4701H17.4718H17.4735H17.4751H17.4768H17.4784H17.4799H17.4814H17.4829H17.4844H17.4858H17.4872H17.4886H17.49H17.4913H17.4925H17.4938H17.495H17.4962H17.4973H17.4984H17.4995H17.5005H17.5015H17.5025H17.5035H17.5044H17.5053H17.5061H17.5069H17.5077H17.5084H17.5091H17.5098H17.5105H17.5111H17.5116H17.5122H17.5127H17.5132H17.5136H17.514H17.5144H17.5147H17.515H17.5153H17.5155H17.5157H17.5158H17.516H17.5161H17.5161L17.5161 35.9883ZM35.5097 31.6806H28.4548V34.7419C28.4548 36.0422 27.397 37.1 26.0968 37.1H15.2581C13.9578 37.1 12.9 36.0422 12.9 34.7419V11.2581C12.9 9.95782 13.9578 8.9 15.2581 8.9H26.0968C27.397 8.9 28.4548 9.95782 28.4548 11.2581V14.3495H35.5097C36.3118 14.3495 36.9645 15.0022 36.9645 15.8043V30.2258C36.9645 31.0279 36.3118 31.6806 35.5097 31.6806ZM24.6419 10.0032H16.7129V10.3548C16.7129 10.5487 16.8709 10.7065 17.0645 10.7065H24.2903C24.4839 10.7065 24.6419 10.5487 24.6419 10.3548V10.0032ZM35.8613 15.8043C35.8613 15.6104 35.7033 15.4527 35.5097 15.4527H20.871C20.6774 15.4527 20.5194 15.6104 20.5194 15.8043V30.2258C20.5194 30.4193 20.6775 30.5774 20.871 30.5774H35.5097C35.7032 30.5774 35.8613 30.4193 35.8613 30.2258V15.8043Z"
                          fill="white" stroke="white" stroke-width="0.2"/>
                      <line x1="28.25" y1="17.25" x2="28.25" y2="28.75" stroke="white"
                            stroke-width="0.5"
                            stroke-linecap="round"/>
                      <line x1="22.25" y1="22.75" x2="33.75" y2="22.75" stroke="white"
                            stroke-width="0.5"
                            stroke-linecap="round"/>
                      <line x1="24.4812" y1="16.9168" x2="24.4813" y2="20.6835" stroke="white"
                            stroke-width="0.9" stroke-linecap="round"/>
                      <line x1="22.615" y1="18.8166" x2="26.3817" y2="18.8166" stroke="white"
                            stroke-width="0.9" stroke-linecap="round"/>
                      <line x1="30.1482" y1="18.8166" x2="33.9149" y2="18.8166" stroke="white"
                            stroke-width="0.9" stroke-linecap="round"/>
                      <line x1="30.45" y1="27.55" x2="33.55" y2="27.55" stroke="white"
                            stroke-width="0.9"
                            stroke-linecap="round"/>
                      <line x1="30.45" y1="25.55" x2="33.55" y2="25.55" stroke="white"
                            stroke-width="0.9"
                            stroke-linecap="round"/>
                      <line x1="25.8184" y1="24.9235" x2="23.1549" y2="27.5869" stroke="white"
                            stroke-width="0.9" stroke-linecap="round"/>
                      <line x1="23.155" y1="24.9473" x2="25.8184" y2="27.6107" stroke="white"
                            stroke-width="0.9" stroke-linecap="round"/>
                    </svg>

                    <p>Завантажити як додаток</p>
                  </div>
                </router-link>
              </div>

            </div>
          </div>

        </div>

        <div class="drop-list" ref="productInfo">

          <div class="item item1" v-bind:class="[dropListAbout !== false ? activeClass: '', ``]">

            <div @click="openDropList1()" class="visible-part">

              <p class="header-text" v-html="currentProd.info.about.header"></p>

              <svg class="plus" width="22" height="22" viewBox="0 0 22 22" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.0274 1.71683V10.0383H1.70665C1.17487 10.0383 0.75 10.4631 0.75 10.9949C0.75 11.522 1.17023 11.9617 1.70665 11.9617H10.0281V20.2832C10.0281 20.815 10.4631 21.25 10.9949 21.25C11.5313 21.25 11.9516 20.8103 11.9516 20.2832V11.9617H20.2724C20.8041 11.9617 21.2392 11.5267 21.2392 10.9949C21.2392 10.4585 20.7995 10.0383 20.2724 10.0383H11.9516V1.71683C11.9516 1.18972 11.5313 0.75 10.9949 0.75C10.463 0.75 10.0283 1.18503 10.0274 1.71643V1.71683Z"
                    fill="#00ACE6" stroke="#00ACE6" stroke-width="0.5"/>
              </svg>
              <svg class="minus" width="22" height="4" viewBox="0 0 22 4" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M0.75 1.99572C0.75 2.52282 1.17023 2.96255 1.70665 2.96255H10.2781H11.7016H20.2724C20.8041 2.96255 21.2392 2.5275 21.2392 1.99572C21.2392 1.45929 20.7995 1.03906 20.2724 1.03906H11.7016H10.2774H1.70665C1.17487 1.03906 0.75 1.46393 0.75 1.99572Z"
                    fill="#00ACE6" stroke="#00ACE6" stroke-width="0.5"/>
              </svg>

            </div>

            <div class="hide-part">
              <p class="reg-text" v-for="(key, value) in currentProd.info.about.text" v-html="key"></p>
            </div>

          </div>

          <div class="item item2" v-bind:class="[dropListCompound !== false ? activeClass: '', ``]">

            <div @click="openDropList2()" class="visible-part">

              <p class="header-text" v-html="currentProd.info.compound.header"></p>

              <svg class="plus" width="22" height="22" viewBox="0 0 22 22" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.0274 1.71683V10.0383H1.70665C1.17487 10.0383 0.75 10.4631 0.75 10.9949C0.75 11.522 1.17023 11.9617 1.70665 11.9617H10.0281V20.2832C10.0281 20.815 10.4631 21.25 10.9949 21.25C11.5313 21.25 11.9516 20.8103 11.9516 20.2832V11.9617H20.2724C20.8041 11.9617 21.2392 11.5267 21.2392 10.9949C21.2392 10.4585 20.7995 10.0383 20.2724 10.0383H11.9516V1.71683C11.9516 1.18972 11.5313 0.75 10.9949 0.75C10.463 0.75 10.0283 1.18503 10.0274 1.71643V1.71683Z"
                    fill="#00ACE6" stroke="#00ACE6" stroke-width="0.5"/>
              </svg>
              <svg class="minus" width="22" height="4" viewBox="0 0 22 4" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M0.75 1.99572C0.75 2.52282 1.17023 2.96255 1.70665 2.96255H10.2781H11.7016H20.2724C20.8041 2.96255 21.2392 2.5275 21.2392 1.99572C21.2392 1.45929 20.7995 1.03906 20.2724 1.03906H11.7016H10.2774H1.70665C1.17487 1.03906 0.75 1.46393 0.75 1.99572Z"
                    fill="#00ACE6" stroke="#00ACE6" stroke-width="0.5"/>
              </svg>

            </div>

            <div class="hide-part">
              <p class="reg-text" v-for="(key, value) in currentProd.info.compound.text" v-html="key"></p>

              <div class="table-wrapper">
                <div class="left-col">
                  <p class="table-text"
                     v-for="(key, value) in currentProd.info.compound.table.leftCol" v-html="key">
                  </p>
                </div>
                <div class="right-col">
                  <p class="table-text"
                     v-for="(key, value) in currentProd.info.compound.table.rightCol"
                     v-html="key"></p>
                </div>
              </div>
            </div>

          </div>

          <div class="item item3"
               v-bind:class="[{ active: dropListPreparation !== false },{ hide: numberProduction.toString() === '24' }]">
            <div @click="openDropList3()" class="visible-part">

              <p class="header-text" v-html="currentProd.info.preparation.header"></p>

              <svg class="plus" width="22" height="22" viewBox="0 0 22 22" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.0274 1.71683V10.0383H1.70665C1.17487 10.0383 0.75 10.4631 0.75 10.9949C0.75 11.522 1.17023 11.9617 1.70665 11.9617H10.0281V20.2832C10.0281 20.815 10.4631 21.25 10.9949 21.25C11.5313 21.25 11.9516 20.8103 11.9516 20.2832V11.9617H20.2724C20.8041 11.9617 21.2392 11.5267 21.2392 10.9949C21.2392 10.4585 20.7995 10.0383 20.2724 10.0383H11.9516V1.71683C11.9516 1.18972 11.5313 0.75 10.9949 0.75C10.463 0.75 10.0283 1.18503 10.0274 1.71643V1.71683Z"
                    fill="#00ACE6" stroke="#00ACE6" stroke-width="0.5"/>
              </svg>
              <svg class="minus" width="22" height="4" viewBox="0 0 22 4" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M0.75 1.99572C0.75 2.52282 1.17023 2.96255 1.70665 2.96255H10.2781H11.7016H20.2724C20.8041 2.96255 21.2392 2.5275 21.2392 1.99572C21.2392 1.45929 20.7995 1.03906 20.2724 1.03906H11.7016H10.2774H1.70665C1.17487 1.03906 0.75 1.46393 0.75 1.99572Z"
                    fill="#00ACE6" stroke="#00ACE6" stroke-width="0.5"/>
              </svg>

            </div>

            <div class="hide-part">

              <div class="line" v-for="(key, value) in currentProd.info.preparation.text">
                <div class="icon" v-html="key.icon"></div>
                <p class="reg-text" v-html="key.text"></p>
              </div>

            </div>

          </div>

          <div v-if="false" class="item item4" v-bind:class="[dropListDoze !== false ? activeClass: '', ``]">

            <div @click="openDropList4()" class="visible-part">

              <p class="header-text" v-html="currentProd.info.doze.header"></p>

              <svg class="plus" width="22" height="22" viewBox="0 0 22 22" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.0274 1.71683V10.0383H1.70665C1.17487 10.0383 0.75 10.4631 0.75 10.9949C0.75 11.522 1.17023 11.9617 1.70665 11.9617H10.0281V20.2832C10.0281 20.815 10.4631 21.25 10.9949 21.25C11.5313 21.25 11.9516 20.8103 11.9516 20.2832V11.9617H20.2724C20.8041 11.9617 21.2392 11.5267 21.2392 10.9949C21.2392 10.4585 20.7995 10.0383 20.2724 10.0383H11.9516V1.71683C11.9516 1.18972 11.5313 0.75 10.9949 0.75C10.463 0.75 10.0283 1.18503 10.0274 1.71643V1.71683Z"
                    fill="#00ACE6" stroke="#00ACE6" stroke-width="0.5"/>
              </svg>
              <svg class="minus" width="22" height="4" viewBox="0 0 22 4" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M0.75 1.99572C0.75 2.52282 1.17023 2.96255 1.70665 2.96255H10.2781H11.7016H20.2724C20.8041 2.96255 21.2392 2.5275 21.2392 1.99572C21.2392 1.45929 20.7995 1.03906 20.2724 1.03906H11.7016H10.2774H1.70665C1.17487 1.03906 0.75 1.46393 0.75 1.99572Z"
                    fill="#00ACE6" stroke="#00ACE6" stroke-width="0.5"/>
              </svg>

            </div>

            <div class="hide-part">

              <div class="table-wrapper">

                <table>

                  <tr class="header-table">
                    <th v-for="(key, value) in currentProd.info.doze.table.tableHeader"
                        v-html="key"></th>
                  </tr>

                  <tr class="tBody" v-for="(key, value) in currentProd.info.doze.table.tableBody">
                    <td v-for="secondKey in key" v-html="secondKey"></td>
                  </tr>

                </table>
              </div>

            </div>

          </div>

          <div class="item item5"
               v-bind:class="[{ active: dropListInstruction !== false },{ hide: numberProduction.toString() === '24' },{ hide: numberProduction.toString() === 'base-1-liquid-POF' }]">
            <div @click="openDropList5()" class="visible-part">

              <p class="header-text" v-html="currentProd.info.instruction.header"></p>

              <svg class="plus" width="22" height="22" viewBox="0 0 22 22" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.0274 1.71683V10.0383H1.70665C1.17487 10.0383 0.75 10.4631 0.75 10.9949C0.75 11.522 1.17023 11.9617 1.70665 11.9617H10.0281V20.2832C10.0281 20.815 10.4631 21.25 10.9949 21.25C11.5313 21.25 11.9516 20.8103 11.9516 20.2832V11.9617H20.2724C20.8041 11.9617 21.2392 11.5267 21.2392 10.9949C21.2392 10.4585 20.7995 10.0383 20.2724 10.0383H11.9516V1.71683C11.9516 1.18972 11.5313 0.75 10.9949 0.75C10.463 0.75 10.0283 1.18503 10.0274 1.71643V1.71683Z"
                    fill="#00ACE6" stroke="#00ACE6" stroke-width="0.5"/>
              </svg>
              <svg class="minus" width="22" height="4" viewBox="0 0 22 4" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M0.75 1.99572C0.75 2.52282 1.17023 2.96255 1.70665 2.96255H10.2781H11.7016H20.2724C20.8041 2.96255 21.2392 2.5275 21.2392 1.99572C21.2392 1.45929 20.7995 1.03906 20.2724 1.03906H11.7016H10.2774H1.70665C1.17487 1.03906 0.75 1.46393 0.75 1.99572Z"
                    fill="#00ACE6" stroke="#00ACE6" stroke-width="0.5"/>
              </svg>

            </div>

            <div class="hide-part">

              <p class="reg-text" v-html="key"
                 v-for="(key, value) in currentProd.info.instruction.text"></p>

            </div>

          </div>

        </div>

      </div>

      <!--      <div class="more-production-wrapper">-->

      <!--        <p class="h2-title">Інші продукти:</p>-->

      <!--        <div class="more-production">-->

      <!--          <div class="item" v-for="(key, value) in moreInfo">-->
      <!--            <div class="description">-->
      <!--              <div class="left">-->
      <!--                <p class="name" v-html="key.name"></p>-->
      <!--                <p class="more-info" v-html="key.moreInfo"></p>-->
      <!--              </div>-->
      <!--              <div class="right">-->
      <!--                <img :src="require(`../assets/img/pack/${key.img[0]}`)" alt="">-->
      <!--              </div>-->
      <!--            </div>-->

      <!--            <div class="open-btn" @click="reloadPage(key.id)">-->
      <!--              <p>Детальніше</p>-->
      <!--            </div>-->
      <!--          </div>-->

      <!--        </div>-->

      <!--      </div>-->
    </div>

  </div>
</template>

<script>
import axios from "axios"
import data from './../text-data/prod'

export default {
  name: 'prod',
  components: {
    data
  },

  data: () => ({
    output: "",
    result: {
      dailyRate: "",
      oneFeeding: "",
      tablespoons: "",
      water: "",
      NumberOfFeedings: 0,
      valueOfSpoone: 0,
      spooneText: '',

    },
    interval: false,

    activeClass: "active",
    allProd: 10,

    dropList1: false,
    dropList2: false,
    dropList3: false,
    error: null,

    days: [
      {
        name: "1 день",
        type: 1,
      },
      {
        name: "2 дні",
        type: 2,
      },
      {
        name: "3 дні",
        type: 3,
      },
      {
        name: "4 дні",
        type: 4,
      },
      {
        name: "5 днів",
        type: 5,
      },
      {
        name: "6 днів",
        type: 6,
      },
      {
        name: "7 днів",
        type: 7,
      },
      {
        name: "8 днів",
        type: 8,
      },
      {
        name: "9 днів",
        type: 9,
      },
      {
        name: "10 днів",
        type: 10,
      },

    ],

    allProdItems: data,

    moreInfo: [],

    currentProd: null,

    dropListAbout: false,
    dropListCompound: false,
    dropListPreparation: false,
    dropListDoze: false,
    dropListInstruction: false,

    filter2Chose: "Вік",
    filter3Chose: "Вкажіть кількість днів",

    weight: 1.8,

    showResult: false,

    filter2Type: "",
    filter3Type: "",

    numberProduction: '',


  }),

  mounted() {
    this.$nextTick(() => {

      if (sessionStorage.getItem("isDetaisOpen") === "open") {
        let element = this.$refs.productInfo;
        this.openDropList1();

        let top = element.getBoundingClientRect().top;

        if (window.matchMedia("(min-width: 426px)").matches) {
          window.scrollTo(0, top);
        }
        if (window.matchMedia("(max-width: 425px)").matches) {
          window.scrollTo(0, top - 60);
        }

        sessionStorage.setItem("isDetaisOpen", "closed");
      }
    });
  },

  beforeMount() {

    if (sessionStorage.getItem("production") === null) {
      this.numberProduction = this.$route.params.id;
      this.$router.push({name: "prod", params: {id: this.numberProduction}}).catch(() => {
      });
    } else if (sessionStorage.getItem("production") !== null) {
      this.numberProduction = sessionStorage.getItem("production")
      this.$router.push({name: "prod", params: {id: sessionStorage.getItem("production")}}).catch(() => {
      });
    } else {
      this.$router.push('/calculator').catch(() => {
      })
    }

    // if (this.$route.params.id === "9") {
    //   this.numberProduction = Math.abs(parseInt(this.$route.params.id));
    //   this.$router.push({name: "prod", params: {id: "base-1-powder-POF"}}).catch(() => {
    //   });
    // }
    // if (this.$route.params.id === "10") {
    //   this.numberProduction = Math.abs(parseInt(this.$route.params.id));
    //   this.$router.push({name: "prod", params: {id: "base-2-powder-POF"}}).catch(() => {
    //   });
    // }
    // if (this.$route.params.id === "19") {
    //   this.numberProduction = Math.abs(parseInt(this.$route.params.id));
    //   this.$router.push({name: "prod", params: {id: "base-3-powder-POF"}}).catch(() => {
    //   });
    // }
    // if (this.$route.params.id === "20") {
    //   this.numberProduction = Math.abs(parseInt(this.$route.params.id));
    //   this.$router.push({name: "prod", params: {id: "base-4-powder-POF"}}).catch(() => {
    //   });
    // }
    // if (this.$route.params.id === "22") {
    //   this.numberProduction = Math.abs(parseInt(this.$route.params.id));
    //   this.$router.push({name: "prod", params: {id: "preterm-powder-Midas"}}).catch(() => {
    //   });
    // }

    this.allProdItems.data.forEach((el) => {
      if (el.id === this.numberProduction.toString()) {
        this.currentProd = el;
      }
    });

    if (this.$route.name === 'prod') {
      if (this.currentProd.filters.type.includes('hi')) {
        this.$router.push({name: "prod-energy", params: {id: this.currentProd.id}}).catch(() => {
        });
      }
    } else {
      if (!this.currentProd.filters.includes('hi')) {
        this.$router.push({name: "prod", params: {id: this.currentProd.id}}).catch(() => {
        });
      }
    }

    const productionShuffled = this.allProdItems.data.sort(() => 0.5 - Math.random());

    let production = productionShuffled.slice(0, 2);

    production.forEach((el) => {
      this.moreInfo.push(el)
    });
  },

  methods: {
    openDropList1() {
      if (this.dropListAbout !== true) {
        this.dropListAbout = true;
      } else {
        this.dropListAbout = false;
      }
    },

    openDropList2() {
      if (this.dropListCompound !== true) {
        this.dropListCompound = true;
      } else {
        this.dropListCompound = false;

      }

    },

    openDropList3() {
      if (this.dropListPreparation !== true) {
        this.dropListPreparation = true;
      } else {
        this.dropListPreparation = false;
      }


    },

    openDropList4() {
      if (this.dropListDoze !== true) {
        this.dropListDoze = true;
      } else {
        this.dropListDoze = false;

      }

    },

    openDropList5() {
      if (this.dropListInstruction !== true) {
        this.dropListInstruction = true;
      } else {
        this.dropListInstruction = false;
      }

    },

    openDropListAge() {
      if (this.dropList2 === false && this.dropList3 !== true) {

        this.dropList2 = true

      } else if (this.dropList2 === false && this.dropList3 === true) {

        setTimeout(() => {
          this.dropList2 = true
        }, 500);

        this.dropList3 = false

      } else {

        this.dropList2 = false
      }
    },

    openDropListAge2() {

      if (this.dropList3 === false && this.dropList2 !== true) {
        this.dropList3 = true
      } else {
        this.dropList3 = false
      }
    },

    choseFilter2(value, name) {

      this.filter2Chose = name;
      this.dropList2 = false;
      this.filter2Type = value;

    },

    choseFilter3(value, name) {

      this.filter3Chose = name;
      this.dropList3 = false;
      this.filter3Type = value;

    },

    calcResult() {
      if (this.filter2Type !== "" && this.weight !== 0) {

        if (this.filter2Type === "10-2") {

          this.result.dailyRate = Math.round((this.weight / 5) * 1000);

          this.result.NumberOfFeedings = 7;

          this.result.oneFeeding = Math.round(this.result.dailyRate / this.result.NumberOfFeedings);

          if (this.result.oneFeeding > 30) {
            this.result.tablespoons = Math.ceil(this.result.oneFeeding / (100 / 3));
          } else {
            this.result.tablespoons = 1;
          }
          // if (this.result.oneFeeding >= 210) {
          //   this.result.oneFeeding = 210
          // }

          // if (this.result.oneFeeding <= 30) {
          //   this.result.tablespoons = 1;
          // }
          // if (this.result.oneFeeding <= 60 && this.result.oneFeeding > 30) {
          //   this.result.tablespoons = 2;
          // }
          // if (this.result.oneFeeding <= 90 && this.result.oneFeeding > 60) {
          //   this.result.tablespoons = 3;
          // }
          // if (this.result.oneFeeding <= 120 && this.result.oneFeeding > 90) {
          //   this.result.tablespoons = 4;
          // }
          // if (this.result.oneFeeding <= 150 && this.result.oneFeeding > 120) {
          //   this.result.tablespoons = 5;
          // }
          // if (this.result.oneFeeding <= 180 && this.result.oneFeeding > 150) {
          //   this.result.tablespoons = 6;
          // }
          // if (this.result.oneFeeding <= 210 && this.result.oneFeeding > 180) {
          //   this.result.tablespoons = 7;
          // }

          this.result.water = this.result.tablespoons * 30;
          this.result.valueOfSpoone = Math.floor(this.result.oneFeeding / this.result.tablespoons);


          this.result.spooneText = this.declOfNum(this.result.tablespoons, ["ложка", "ложки", "ложок"]);
          this.showResult = true;

        }

        if (this.filter2Type === "2") {

          this.result.dailyRate = Math.round((this.weight / 6) * 1000);

          this.result.NumberOfFeedings = 6;

          this.result.oneFeeding = Math.round(this.result.dailyRate / this.result.NumberOfFeedings);

          if (this.result.oneFeeding > 30) {
            this.result.tablespoons = Math.ceil(this.result.oneFeeding / (100 / 3));
          } else {
            this.result.tablespoons = 1;
          }
          this.result.water = this.result.tablespoons * 30;
          this.result.valueOfSpoone = Math.floor(this.result.oneFeeding / this.result.tablespoons);


          this.result.spooneText = this.declOfNum(this.result.tablespoons, ["ложка", "ложки", "ложок"]);
          this.showResult = true;
        }

        if (this.filter2Type === "3") {

          this.result.dailyRate = Math.round((this.weight / 6) * 1000);

          this.result.NumberOfFeedings = 5;

          this.result.oneFeeding = Math.round(this.result.dailyRate / this.result.NumberOfFeedings);

          if (this.result.oneFeeding > 30) {
            this.result.tablespoons = Math.ceil(this.result.oneFeeding / (100 / 3));
          } else {
            this.result.tablespoons = 1;
          }
          this.result.water = this.result.tablespoons * 30;
          this.result.valueOfSpoone = Math.floor(this.result.oneFeeding / this.result.tablespoons);


          this.result.spooneText = this.declOfNum(this.result.tablespoons, ["ложка", "ложки", "ложок"]);
          this.showResult = true;
        }

        if (this.filter2Type === "4") {

          this.result.dailyRate = Math.round((this.weight / 7) * 1000);

          this.result.NumberOfFeedings = 5;

          this.result.oneFeeding = Math.round(this.result.dailyRate / this.result.NumberOfFeedings);

          if (this.result.oneFeeding > 30) {
            this.result.tablespoons = Math.ceil(this.result.oneFeeding / (100 / 3));
          } else {
            this.result.tablespoons = 1;
          }
          this.result.water = this.result.tablespoons * 30;
          this.result.valueOfSpoone = Math.floor(this.result.oneFeeding / this.result.tablespoons);


          this.result.spooneText = this.declOfNum(this.result.tablespoons, ["ложка", "ложки", "ложок"]);
          this.showResult = true;
        }

        if (this.filter2Type === "5") {

          this.result.dailyRate = Math.round((this.weight / 7) * 1000);

          this.result.NumberOfFeedings = 5;

          this.result.oneFeeding = Math.round(this.result.dailyRate / this.result.NumberOfFeedings);

          if (this.result.oneFeeding > 30) {
            this.result.tablespoons = Math.ceil(this.result.oneFeeding / (100 / 3));
          } else {
            this.result.tablespoons = 1;
          }
          this.result.water = this.result.tablespoons * 30;
          this.result.valueOfSpoone = Math.floor(this.result.oneFeeding / this.result.tablespoons);


          this.result.spooneText = this.declOfNum(this.result.tablespoons, ["ложка", "ложки", "ложок"]);
          this.showResult = true;
        }

        if (this.filter2Type === "6") {

          this.result.dailyRate = Math.round((this.weight / 8.5) * 1000);

          this.result.NumberOfFeedings = 4;

          this.result.oneFeeding = Math.round(this.result.dailyRate / this.result.NumberOfFeedings);

          if (this.result.oneFeeding > 30) {
            this.result.tablespoons = Math.ceil(this.result.oneFeeding / (100 / 3));
          } else {
            this.result.tablespoons = 1;
          }
          this.result.water = this.result.tablespoons * 30;
          this.result.valueOfSpoone = Math.floor(this.result.oneFeeding / this.result.tablespoons);


          this.result.spooneText = this.declOfNum(this.result.tablespoons, ["ложка", "ложки", "ложок"]);
          this.showResult = true;
        }

        if (this.filter2Type === "6-12") {

          this.result.dailyRate = Math.round((this.weight / 8.5) * 1000);

          this.result.NumberOfFeedings = 4;

          this.result.oneFeeding = Math.round(this.result.dailyRate / this.result.NumberOfFeedings);

          if (this.result.oneFeeding > 30) {
            this.result.tablespoons = Math.ceil(this.result.oneFeeding / (100 / 3));
          } else {
            this.result.tablespoons = 1;
          }
          this.result.water = this.result.tablespoons * 30;
          this.result.valueOfSpoone = Math.floor(this.result.oneFeeding / this.result.tablespoons);


          this.result.spooneText = this.declOfNum(this.result.tablespoons, ["ложка", "ложки", "ложок"]);
          this.showResult = true;
        }

      }

      if (this.filter2Type !== "") {
        if (this.filter2Type === "0-10" && this.filter3Type !== "") {

          this.result.dailyRate = Math.round(this.filter3Type * 75);

          this.result.oneFeeding = Math.round(this.result.dailyRate / 7);
          this.result.NumberOfFeedings = 7;

          if (this.result.oneFeeding > 30) {
            this.result.tablespoons = Math.ceil(this.result.oneFeeding / (100 / 3));
          } else {
            this.result.tablespoons = 1;
          }

          this.result.water = this.result.tablespoons * 30;
          this.result.valueOfSpoone = Math.floor(this.result.oneFeeding / this.result.tablespoons);

          this.result.spooneText = this.declOfNum(this.result.tablespoons, ["ложка", "ложки", "ложок"]);
          this.showResult = true;
        }

      }

    },

    async saveImg() {
      const el = this.$refs.printMe;


      let options = {
        allowTaint: true,
        type: "dataURL"
      };
      this.output = await this.$html2canvas(el, options);

      this.saveAs(this.output, this.currentProd.name.replace(/ /g, '') + '.png');
    },

    async sendToServerScreen() {

      const el = this.$refs.printMe;

      let options = {
        allowTaint: true,
        type: "dataURL"
      };
      this.output = await this.$html2canvas(el, options);

      let myFormData = new FormData();
      let blob = this.dataURItoBlob(this.output);
      myFormData.append("picture", blob);


      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem("key");

      axios.post(this.$root.globalUrl + "api/v1/calculator/save_calc_result", myFormData, {
        headers: {
          "content-type": "multipart/form-data"
        }
      }).then(res => {
        let img = res.data.data.hash;
        document
            .getElementById("viber_share")
            .setAttribute(
                "href",
                "https://3p3x.adj.st/?adjust_t=u783g1_kw9yml&adjust_fallback=https%3A%2F%2Fwww.viber.com%2F%3Futm_source%3DPartner%26utm_medium%3DSharebutton%26utm_campaign%3DDefualt&adjust_campaign=Sharebutton&adjust_deeplink=" +
                encodeURIComponent(
                    "viber://forward?text=" +
                    encodeURIComponent(this.$root.globalUrl + "" + "uploads/calculator/" + img)
                )
            );
        document.getElementById("viber_share").click();
      })

    },

    dataURItoBlob(dataURI) {
      // convert base64 to raw binary data held in a string
      var byteString = atob(dataURI.split(",")[1]);

      // separate out the mime component
      var mimeString = dataURI
          .split(",")[0]
          .split(":")[1]
          .split(";")[0];

      // write the bytes of the string to an ArrayBuffer
      var arrayBuffer = new ArrayBuffer(byteString.length);
      var _ia = new Uint8Array(arrayBuffer);
      for (var i = 0; i < byteString.length; i++) {
        _ia[i] = byteString.charCodeAt(i);
      }

      var dataView = new DataView(arrayBuffer);
      var blob = new Blob([dataView], {type: mimeString});
      return blob;
    },

    saveAs(uri, filename) {
      let link = document.createElement('a');

      if (typeof link.download === 'string') {

        link.href = uri;
        link.download = filename;

        //Firefox requires the link to be in the body
        document.body.appendChild(link);

        //simulate click
        link.click();

        //remove the link when done
        document.body.removeChild(link);

      } else {

        window.open(uri);

      }
    },

    stop() {
      clearInterval(this.interval)
      this.interval = false
    },

    startPlus() {
      if (!this.interval) {
        this.interval = setInterval(() => {
          if (this.weight <= 14.9) {
            this.weight = +Math.abs(this.weight + 0.1).toFixed(1);
          }
        }, 50)
      }
    },

    startMinus() {
      if (!this.interval) {
        this.interval = setInterval(() => {
          if (this.weight >= 1.9) {
            this.weight = +Math.abs(this.weight - 0.1).toFixed(1);
          }
        }, 50)
      }
    },

    plusWeight() {
      if (this.weight <= 14.8) {
        this.weight = +Math.abs(this.weight + 0.1).toFixed(1);
      }
    },

    minusWeight() {
      if (this.weight >= 1.9) {
        this.weight = +Math.abs(this.weight - 0.1).toFixed(1);
      }
    },

    reloadPage(id) {
      window.scrollTo(0, 0);
      sessionStorage.setItem("production", id);
      // this.$router.go("/calc/prod")
      this.$router.push({name: 'prod', params: {id: id}});
      this.$router.go();
    },

    declOfNum(number, titles) {
      let cases = [2, 0, 1, 1, 1, 2];
      return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
    },

  }
}
</script>

<style lang="scss">
@import "../style/vars";

.production {
  position: relative;

  * {
    user-select: none;
  }

  .head-links {
    background-color: rgba(255, 255, 255, 0.49);
    width: 100%;
    padding: 10px 15px;

    .back-links {
      color: #7392B1;
      font-family: $fontR;
      font-size: 11px;
    }

    span {
      padding: 0 5px;
      color: #7392B1;
      font-family: $fontR;
      font-size: 11px;
    }

    .now-page {
      color: #00ACE6;
      font-family: $fontSB;
      font-size: 11px;
    }
  }

  .content-wrapper {
    padding: 0 15px;
    margin-bottom: 30px;


    .content {
      border-radius: 4px;
      background: white;

      display: flex;
      flex-direction: column;
      align-items: center;

      .production-block {
        background: #D5EAF8;
        border-radius: 4px;
        width: 100%;

        .hide {
          &.active {
            display: none;
          }
        }


        .production-item {
          padding: 15px;
          border-bottom: 1px solid rgba(30, 59, 137, 0.25);

          .name {
            font-family: $fontSB;
            font-size: 15px;
            color: #1E3B89;
          }

          .type {
            color: #1E3B89;
            font-size: 12px;
            font-family: $fontL;

          }

          img {
            display: block;
            max-width: 140px;
            max-height: 220px;
            width: 100%;
            height: auto;
            margin: 10px auto;
            object-fit: contain;
          }
        }

        .drop-item1 {
          border-bottom: 1px solid rgba(30, 59, 137, 0.25);
          padding: 15px;
          position: relative;
          display: flex;
          justify-content: center;
          flex-direction: column;
          transition: background-color .5s ease;

          &.hide {
            display: none;
          }


          .visible-item {
            display: flex;
            flex-direction: row;
            align-items: center;

            span {
              display: flex;
              font-size: 15px;
              font-family: $fontR;
              color: #1E3B89;
            }

            .icon {
              display: flex;
              margin-right: 20px;
            }

            .arrow {
              transition: transform .2s ease;
              display: flex;
              margin-left: auto;
              cursor: pointer;
            }
          }

          .hide-item {
            padding: 0 15px;
            z-index: 10;
            position: absolute;
            top: 57px;
            left: 0;
            width: 100%;
            max-height: 0;
            background: #D5EAF8;
            overflow: hidden;
            transition: padding .5s ease, max-height .5s ease;


            p {
              padding: 10px 0;
              color: #1E3B89;
              font-size: 15px;
              font-family: $fontL;

              &.active, &:hover {
                font-family: $fontR;
              }
            }
          }

          &.active {

            .hide-item {
              border-top: 1px solid #DAE3ED;
              max-height: 500px;
              padding: 10px 15px;
            }

            .arrow {
              transform: rotate(180deg);
            }
          }
        }

        .drop-item2 {
          border-bottom: 1px solid rgba(30, 59, 137, 0.25);
          padding: 15px;
          position: relative;
          display: flex;
          justify-content: center;
          flex-direction: column;
          transition: background-color .5s ease;

          &.hide {
            display: none;
          }


          .visible-item {
            display: flex;
            flex-direction: row;
            align-items: center;

            span {
              display: flex;
              font-size: 15px;
              font-family: $fontR;
              color: #1E3B89;
            }

            .icon {
              display: flex;
              margin-right: 20px;
            }

            .arrow {
              transition: transform .2s ease;
              display: flex;
              margin-left: auto;
            }
          }

          .hide-item {
            padding: 0 15px;
            z-index: 10;
            position: absolute;
            top: 57px;
            left: 0;
            width: 100%;
            max-height: 0;
            background: #D5EAF8;
            overflow: hidden;
            transition: padding .5s ease, max-height .5s ease;


            p {
              padding: 10px 0;
              color: #1E3B89;
              font-size: 15px;
              font-family: $fontL;

              &.active, &:hover {
                font-family: $fontR;
              }
            }
          }

          &.active {

            .hide-item {
              border-top: 1px solid #DAE3ED;
              max-height: 500px;
              padding: 10px 15px;
            }

            .arrow {
              transform: rotate(180deg);
            }
          }
        }

        .weight-block {
          display: flex;
          padding: 0 15px;

          &.hide {
            display: none;
          }


          .left {
            border-right: 1px solid rgba(30, 59, 137, 0.25);
            padding: 8px 0;
            width: 45%;
            margin: 10px 0;
            display: flex;
            align-items: center;

            svg {
              margin-right: 20px;
            }

            p {
              font-size: 15px;
              font-family: $fontR;
              color: #1E3B89;
            }
          }

          .right {
            width: 55%;
            display: flex;
            justify-content: space-around;
            align-items: center;
            cursor: pointer;

            p {
              font-size: 15px;
              font-family: $fontR;
              color: #1E3B89;
            }

            .minus {
              height: 25px;
              display: flex;
              align-items: center;
            }
          }
        }

        .calc-btn-wrapper {
          padding: 20px 15px 15px 15px;
          border-top: 1px solid rgba(30, 59, 137, 0.25);

          &.hide {
            display: none;
          }


          .calc-btn {
            width: 100%;
            height: 40px;
            background: #00ACE6;
            border-radius: 4px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;

            p {
              font-size: 14px;
              letter-spacing: 0.05em;
              font-family: $fontB;
              text-transform: uppercase;
              color: white;
            }
          }

          .sampling-btn {
            width: 100%;
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 10px;
            color: #00ACE6;
            border: 1px solid #00ACE6;
            background-color: transparent;
            border-radius: 4px;
            cursor: pointer;

            p {
              letter-spacing: 0.05em;
              text-transform: uppercase;

              color: #00ACE6;
              font-size: 14px;
              font-family: $fontB;
            }
          }
        }

        .result-wrapper {
          max-height: 0;
          overflow: hidden;
          transition: padding .5s ease, max-height .5s ease;

          &.active {
            max-height: 1000px;
            padding: 0 0 0 0;
          }

          .result-img {
            background-color: #D5EAF8;
            padding: 30px 0 20px 0;
          }

          .line {
            padding: 0 15px;
            display: flex;
            flex-direction: row;
            margin-bottom: 30px;

            &:last-child {
              margin-bottom: 0;
            }

            .icon-wrapper {
              min-width: 35px;
              margin-right: 20px;
            }

            p {
              font-family: $fontR;
              font-size: 14px;
              color: #1E3B89;

              span {
                font-size: 15px;
                font-family: $fontB;

                span {
                  font-size: 20px;
                }
              }
            }
          }

          .save-btn {
            background: #1E3B89;
            border-radius: 4px;
            padding: 15px;
            display: flex;
            justify-content: space-between;
            cursor: pointer;

            .btns {
              width: 96px;
              display: flex;
              flex-direction: column;
              align-items: center;

              p {
                margin-top: 10px;
                text-align: center;
                font-size: 12px;
                color: white;
                font-family: $fontR;
              }
            }

          }
        }
      }

      .drop-list {

        .item1 {
          padding: 0 15px;
          border-bottom: 1px solid rgba(30, 59, 137, 0.25);


          .visible-part {
            height: 60px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .header-text {
              font-size: 15px;
              color: #1E3B89;
              font-family: $fontR;
            }
          }

          .hide-part {
            padding: 0;

            .reg-text {
              font-size: 14px;
              font-family: $fontL;
              color: #1E3B89;
              margin-bottom: 10px;

              span {
                font-family: $fontSB;
              }
            }
          }

        }

        .item2 {
          border-bottom: 1px solid rgba(30, 59, 137, 0.25);

          .visible-part {
            padding: 0 15px;
            height: 60px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .header-text {
              font-size: 15px;
              color: #1E3B89;
              font-family: $fontR;
            }
          }

          .hide-part {
            padding: 0;

            .reg-text {
              padding: 0 15px;

              font-size: 14px;
              font-family: $fontL;
              color: #1E3B89;
              margin-bottom: 10px;

              span {
                font-family: $fontSB;
              }
            }

            .table-wrapper {
              margin-top: 30px;

              display: flex;
              flex-direction: row;


              .left-col {

                width: 60%;

                p {
                  padding: 0 0 0 15px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  margin: auto 0;
                  height: 60px;
                  text-align: center;
                  font-family: $fontL;
                  font-size: 13px;
                  color: #1E3B89;

                  b {
                    font-family: $fontL;
                    font-weight: inherit;
                  }

                  &:nth-child(2n) {
                    background: #CBDFF2;
                  }

                  &:nth-child(2n+1) {
                    background: #E0ECF7;
                  }

                  &:nth-child(1) {
                    border-radius: 5px 0 0 0;
                    color: white;
                    font-family: $fontR;
                    background: #00ACE6;
                  }


                  span {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    font-family: $fontSB;
                    text-align: left;
                    margin-right: auto;
                  }
                }
              }

              .right-col {
                width: 40%;

                p {
                  padding: 0 15px 0 0;

                  justify-content: center;
                  display: flex;
                  align-items: center;
                  height: 60px;
                  text-align: center;
                  font-family: $fontL;
                  font-size: 13px;
                  color: #1E3B89;

                  &:nth-child(2n) {
                    background: #CBDFF2;
                  }

                  &:nth-child(2n+1) {
                    background: #E0ECF7;
                  }

                  &:nth-child(1) {
                    border-left: 1px solid white;
                    font-family: $fontR;
                    border-radius: 0 5px 0 0;
                    color: white;
                    background: #00ACE6;
                  }

                  span {

                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    font-family: $fontB;
                    text-align: left;
                  }
                }
              }
            }


          }

        }

        .item4 {
          border-bottom: 1px solid rgba(30, 59, 137, 0.25);

          .visible-part {
            padding: 0 15px;
            height: 60px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .header-text {
              font-size: 15px;
              color: #1E3B89;
              font-family: $fontR;
            }
          }

          .hide-part {
            .table-wrapper {
              -webkit-overflow-scrolling: auto;
              overflow-x: auto;
            }

            table {
              min-width: 600px;
              border-collapse: collapse;

              * {
                border-top: 0;
                border-left: 0;
                border-bottom: 0;
                border-right: 0;

              }

              .header-table {
                background: #00ACE6;
                border: none;

                th {
                  &:first-child {
                    border-radius: 5px 0 0 0;
                  }

                  &:last-child {
                    border-radius: 0 5px 0 0;
                  }

                  color: white;
                  padding: 5px 10px;
                  text-align: center;
                  vertical-align: center;
                  font-size: 14px;
                  font-family: $fontSB;
                }
              }

              .tBody {
                &:nth-child(2n +1) {
                  background: #E0ECF7;
                }

                &:nth-child(2n) {
                  background: #CBDFF2;
                }

                td {
                  width: 20%;
                  text-align: center;
                  vertical-align: center;
                  padding: 10px 10px;
                  font-family: $fontL;
                  font-size: 14px;
                  color: #1E3B89;


                }
              }
            }
          }
        }

        .item3 {
          border-bottom: 1px solid rgba(30, 59, 137, 0.25);

          &.hide {
            display: none;
          }

          .visible-part {
            padding: 0 15px;
            height: 60px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .header-text {
              font-size: 15px;
              color: #1E3B89;
              font-family: $fontR;
            }
          }

          .hide-part {
            padding: 0;

            .line {
              padding: 0 15px;
              margin-bottom: 10px;
              display: flex;
              flex-direction: row;

              .icon {
                display: flex;
                justify-content: center;
                min-width: 60px;
                margin-right: 10px;

              }

              .reg-text {
                padding: 0 15px;

                font-size: 14px;
                font-family: $fontL;
                color: #1E3B89;
                margin-bottom: 10px;

                span {
                  font-family: $fontSB;
                }
              }
            }

          }

        }

        .item5 {
          &.hide {
            display: none;
          }

          .visible-part {
            padding: 0 15px;
            height: 60px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .header-text {
              font-size: 15px;
              color: #1E3B89;
              font-family: $fontR;
            }
          }

          .hide-part {
            padding: 0;

            .reg-text {
              padding: 0 15px;

              font-size: 14px;
              font-family: $fontL;
              color: #1E3B89;
              margin-bottom: 10px;


              a {
                color: #1E3B89;
                text-decoration: underline;
              }

              span {
                font-family: $fontSB;
              }
            }

          }
        }

        .item {
          &:last-child {
            border-bottom: none !important;
          }

          .hide-part {
            transition: padding-top 500ms ease, padding-bottom 500ms ease, max-height .2s ease;
            overflow: hidden;
            max-height: 0;
          }

          .plus {
            display: block;
          }

          .minus {
            display: none;
          }

          &.active {
            .plus {
              display: none;
            }

            .minus {
              display: block;
            }

            .hide-part {
              max-height: 20000px;
            }
          }

          &.item1 {
            &.active {
              .hide-part {
                padding: 15px 0;
              }
            }
          }

          &.item2 {
            &.active {
              .hide-part {
                padding: 15px 0 0 0;
              }

            }
          }

          &.item3 {
            &.active {
              .hide-part {
                padding: 15px 0;
              }

            }
          }

          &.item4 {
            &.active {
              .hide-part {
                padding: 15px 0 0 0;
              }
            }
          }

          &.item5 {
            &.active {
              .hide-part {
                padding: 15px 0;
              }
            }
          }
        }
      }

    }

    .visible-part {
      svg {
        cursor: pointer;
      }
    }

    .more-production-wrapper {
      margin-top: 30px;

      .h2-title {
        margin-bottom: 12px;
        font-family: $fontSB;
        font-size: 16px;
        color: #9AB9D8;
        text-align: center;
        letter-spacing: 1px;
      }

      .more-production {

        .item {
          margin-bottom: 20px;
          background: #FFFFFF;
          border-radius: 4px;
          padding: 15px;

          .description {
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            .left {
              max-width: 140px;

              .name {
                font-size: 15px;
                line-height: 18px;

                color: #1E3B89;
                font-family: $fontSB;
              }

              .more-info {
                margin-top: 5px;
                font-family: $fontL;
                font-size: 12px;
                color: rgba(30, 59, 137, 0.7);
              }
            }

            .right {
              max-width: 115px;
              width: 100%;
              cursor: pointer;

              img {
                display: block;
                width: 100%;
                height: auto;
                object-fit: contain;
                max-height: 220px;
              }
            }
          }

          .open-btn {
            margin: 10px auto 0 auto;
            border: 1px solid #00ACE6;
            box-sizing: border-box;
            border-radius: 4px;
            max-width: 200px;
            width: 100%;
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;

            p {
              color: #00ACE6;
              font-family: $fontB;
              font-size: 14px;
              text-transform: uppercase;
              letter-spacing: 0.05em;
            }
          }
        }

      }
    }
  }
}

</style>
